
<style lang="scss" scoped>
.uc-password {
    border: 1px solid #4b8df8;
    margin-bottom: 15px;
    &-title {
        line-height: 40px;
        background-color: #4b8df8;
        color: #fff;
        padding: 0 15px;
    }
    &-content {
        .uc-item {
            border-bottom: 1px solid #ccc;
            padding: 5px 60px 30px 10px;
            margin: 0;
            &:first-child {
                padding: 5px 10px;
            }
        }
    }
}
</style>
<template>
<div>
 	<Bread v-bind="bread"/>
	<div class="uc-password">
		<h3 class="uc-password-title">
			<Icon type="ios-key" size='16'></Icon>
			{{$t('port.password.title')}}
		</h3>
		<Form class="uc-password-content" ref="form" :model='formData' :rules="rules" :label-width='200'>
			<FormItem :label="$t('port.password.nick')" class="uc-item">
				<span>{{userinfo.name}}&nbsp;({{userinfo.id}})</span>
			</FormItem>
			<FormItem prop='password' :label="$t('port.password.password')" class="uc-item">
				<Input type='password' v-model="formData.password" />
			</FormItem>
			<FormItem prop='new_password' :label="$t('port.password.new_password')" class="uc-item">
				<Input type='password' v-model="formData.new_password" />
			</FormItem>
			<FormItem prop='re_password' :label="$t('port.password.re_password')" class="uc-item">
				<Input type='password' v-model="formData.re_password" />
			</FormItem>
		</Form>
		<div class="text-center">
			<Button class="margin-10" type="warning" @click="submit">{{$t('port.password.submit')}}</Button>
			<Button class="margin-10" type="success" @click="$router.push({name:'panel'})">{{$t('port.password.home')}}</Button>
		</div>
	</div>
</div>
</template>


<script>
import Bread from '@/components/bread';
import { mapState } from 'vuex';
import { HttpUpdatePassword } from '@/service/port';
export default {
	components: {
		Bread,
	},
	data() {
		return {
			formData: {
				password: '',
				new_password: '',
				re_password: '',
			},
		};
	},
	computed: {
		...mapState(['userinfo', 'lang']),
		rules() {
			const isEn = this.lang === 'en';
			return {
				password: [
					{
						required: true,
						message: this.$t('global.form.required', {
							defaultValue: '该信息不能为空,请填写'
						}),
					}
				],
				new_password: [
					{
						required: true,
						message: this.$t('global.form.required', {
							defaultValue: '该信息不能为空,请填写'
						}),
					},
					{
						validator: (rule, value, callback) => {
							let tip;
							if (value.length < 8 || !(/[a-z]+/i.test(value) && /\d+/.test(value))) {
								tip = this.$t('global.password.rule', {
									defaultValue: '必须包含数字字母,密码长度不能少于八位'
								});
							}
							callback(tip ? new Error(tip) : undefined);
						},
					},
				],
				re_password: [
					{
						required: true,
						message: this.$t('global.form.required', {
							defaultValue: '该信息不能为空,请填写'
						}),
					},
					{
						validator: (rule, value, callback) => {
							let tip;
							if (value.length < 8 || !(/[a-z]+/i.test(value) && /\d+/.test(value))) {
								tip = this.$t('global.password.rule', {
									defaultValue: '必须包含数字字母,密码长度不能少于八位'
								});
							}
							if (value !== this.formData.new_password) {
								tip = this.$t('global.password.same_password', {
									defaultValue: '请确认密码一致'
								});
							}
							callback(tip ? new Error(tip) : undefined);
						},
					},
				],
			};
		},
		bread() {
			let data = {};
			switch (this.lang) {
				case 'en':
					data = {
						title: 'Edit Password',
						home: 'Main Panel ',
					};
					break;
				default:
					data = {
						title: this.$t('port.profile.edit_pwd',{defaultValue: "修改密码"}),
                        home: this.$t('port.profile.main_panel',{defaultValue: "主面板"}),
					};
					break;
			}
			return data;
		},
	},
	methods: {
		submit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					const formData = this.formData;
					HttpUpdatePassword({
						password: formData.password,
						new_password: formData.new_password,
						uid: this.userinfo.id,
					}).then(
						res => {
							this.$router.push({
								name: 'login',
							});
						},
						res => {
							this.$Message.error(res.message);
						}
					);
				}
			});
		},
	},
};
</script>
